module.exports = __webpack_public_path__ + "static/media/pencil-ruler.8a55eb40.svg";